import { debounce, throttle } from "lodash";
import { onLargeScreen } from "./breakpoint-detect";
declare const jQuery: any;
const $ = jQuery;

export function initLogoLinkMobileSrc(): void
{
	const $imgs = $(`.logo-link img[data-mobile-src]`);
	if ($imgs.length === 0)
	{
		return;
	}
	$imgs.each(function () {
		const $img = $(this);
		const lgSrc = $img.attr("src");
		const smSrc = $img.attr("data-mobile-src");
		const fix = () => {
			$img.attr("src", onLargeScreen() ? lgSrc : smSrc);
		};
		fix();
		$img.removeAttr("data-mobile-src");
		$(window).on("resize load", throttle(fix, 80));
	});
}
